import React, {Component} from 'react';
import {FormGroup, FormControl, ControlLabel, Col, Glyphicon} from 'react-bootstrap';

export default class TextField extends Component {

	render() {

		const {
			feedbackIcon,
			input,
			label,
			title,
			feedbackSuccess,
			meta: {error, warning, touched, asyncValidating},
			sizes,
			onChangeHook,
			quickValues,
			...props
		} = this.props;

		let message;
		const validationState = touched ? ( error && "error" ) || ( warning && "warning" ) || (!props.disabled && feedbackSuccess && input.value ? "success" : null) : null;
		const icon = feedbackIcon ? feedbackIcon : ((!props.disabled && validationState === "success" && feedbackSuccess && input.value) ? <Glyphicon glyph="ok" /> : null)

		if (touched && ( error || warning )) {
			message = <span className="help-block">{error || warning}</span>;
		}

		return (
			<FormGroup controlId={input.name} validationState={validationState} className={"row" + (asyncValidating ? " loading" : "")} title={title}>
				<Col sm={sizes && sizes[0] ? sizes[0] : 4} componentClass={ControlLabel}>{label}</Col>
				<Col sm={sizes && sizes[1] ? sizes[1] : 8}>
					<FormControl {...props} {...input} onChange={(e) => {
						if (onChangeHook) {
							onChangeHook((e.target || e).value);
						}
						input.onChange(e);
					}}/>
					{!input.value && quickValues && quickValues.length > 0 && quickValues
						.map((quickValue, i) =>
							<button key={i} className={'btn btn-secondary btn-quick btn-xs pull-right'} onClick={(e) => {
								e.preventDefault();
								const v = quickValue;
								if (onChangeHook) {
									onChangeHook(v)
								}
								input.onChange(v);
							}}>{quickValue}</button>)}
					{icon ? <FormControl.Feedback>{icon}</FormControl.Feedback> : null}
					{message}
				</Col>
			</FormGroup>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/form/TextField.js